'use client'

import { GoogleAnalytics } from '@next/third-parties/google'
import { usePathname } from 'next/navigation'
import { Suspense } from 'react'
import { GoogleAnalyticsTracker } from './GoogleAnalyticsTracker'
import { TaekwondoAnalytics } from './TaekwondoAnalytics'
import { getTaekwondoSurface } from '@/lib/analytics/taekwondo'

/**
 * 공개 화면의 GA4 목적지를 경로별로 완전히 분리합니다.
 *
 * - 태권낭자: 전용 속성만 로드
 * - 그 외 공개 화면: 기존 공용 속성만 로드
 *
 * 따라서 태권낭자 page_view와 커스텀 이벤트가 기존 공용 속성에 중복 적재되지 않습니다.
 */
export function PublicGoogleAnalytics({ generalGaId }: { generalGaId?: string }) {
  const pathname = usePathname()

  if (getTaekwondoSurface(pathname || '')) {
    return <TaekwondoAnalytics />
  }

  if (!generalGaId) return null

  return (
    <>
      <GoogleAnalytics gaId={generalGaId} />
      <Suspense fallback={null}>
        <GoogleAnalyticsTracker gaId={generalGaId} />
      </Suspense>
    </>
  )
}
